export default () => {
  function handleParentClick(e, item) {
    // get parent menu of clicked
    let activeParentMenu = item.parent().parent();
    let htmlRoot = document.getElementsByTagName('HTML')[0];

    // item.parent.classList.add("is-open");

    if (
      item.parent().hasClass('is-open') &&
      !item
        .parent()
        .parent()
        .hasClass('primaryNav')
    ) {
      item.parent().removeClass('is-open');
    } else if (
      item.parent().hasClass('is-open') &&
      item
        .parent()
        .parent()
        .hasClass('primaryNav')
    ) {
      htmlRoot.classList.remove('navOpen');

      item.parent().removeClass('is-open');
    } else {
      // .nav-menu-parent > .nav-menu-parent
      activeParentMenu.children().each(function(index) {
        $(this).removeClass('is-open');
      });
      htmlRoot.classList.add('navOpen');
      item.parent().addClass('is-open');
      console.log('fix');
    }
  }

  $('.nav-menu-parent > .nav-menu-item-link').each(function(index) {
    $(this).on('click', e => {
      e.preventDefault();
      handleParentClick(e, $(this));
    });
  });
};